import LocationList from './LocationList'
import orgService from '../../../services/notisphere/organization'

export default {
    components: {
        LocationList
    },
    data() {
        return {
            providerOrgId: null,
            listProvider: [],
            locationListKey: 0,
            show: false,
        }
    },
    mounted(){
        this.findProviders()
    },
    watch: {
        providerOrgId() {
            if(this.providerOrgId === null)
            {
                this.show = false
            }
            else
            {
                this.show = false
                this.locationListKey += 1
                this.$nextTick(()=>{
                    this.show = true
                })
            }
        }
    },
    methods: {
        findProviders() {
            orgService.findMeta('PROVIDER').then(resp => {
                this.listProvider = resp.data.d
            })
        }
    }
}